// Check if the body has livetrade-layout class
if (document.body.classList.contains("livetrade-buttons")) {

    // Get all elements with class new-btn
    let newBtns = document.querySelectorAll('.new-btn');

    // Loop through each element and add the new-btn-secondary class
    newBtns.forEach(function(btn) {
        btn.classList.add('new-btn-secondary');
    });
}